export const FormErrorMessage = {
  invalid: "${path}を正しく入力してください",
  invalidBithDate: "生年月日に未来日は指定できません",
  required: "${path}を入力してください",
};
